import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';

import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms';

import { ToastMessageService } from '@fitness-force/api';
import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';

import { CommonModule } from '@angular/common';
import { InputMaskModule } from 'primeng/inputmask';
import {
  ChargeBreakUp,
  ChargingTodaySignUp,
  Claim,
  ClaimConstant,
  Crm,
  OverLappingSubscriptionSignUpResponse,
  PaymentSignUp,
  PlanBreakUpCalculation,
  PlanBreakUpCalculationResponse,
  PlanMasterList,
  PlanSummary,
  RecurringSignUp,
  ServiceBreakUp,
  ServiceTypeResponse,
  TaxLineItemBreakUp,
  TenantById,
  ValidationError,
  ChargeMaster,
  ChargeMasterById,
  ChargeBreakUpCalculationRequest,
  ClientOrderResponse,
  TENANTSINTERFACE,
  ChargeCreateRequest,
  StaffDiscountSignUpChargeRequest,
  StaffDiscountCalculationRequest,
  StaffDiscountChargeRecurring,
  StaffDiscountChargingTodayRequest,
  StaffDiscountServiceFirstChargeRequest,
  StaffDiscountServiceNonRecurringRequest,
  StaffDiscountServiceRecurringRequest,
  STAFFINTERFACE
} from '@fitness-force/models';
import { BehaviorSubject, catchError, combineLatestWith, map, Observable, retryWhen, scan, switchMap, throwError, timer } from 'rxjs';
import {
  AdvancedSettingService,
  AuthSevices,
  ChargeMasterService,
  ClaimService,
  ClientService,
  CommonService,
  PaymentModeService,
  PlansubscriptionService,
  StaffService,
  TimeconversionService,
} from '@fitness-force/api';
import {
  AppErrors,
  NotFoundError,
  ErrorMsgComponent,
} from '@fitness-force/errors';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ErrorsComponent,} from '@fitness-force/common/errors'
import {AssignedToComponent} from '@fitness-force/common/assigned-to'

import {
  PlanIntervalType,
  PlanType,
  Roles,
  Status,
} from '@fitness-force/enum';
import {
  ROUTER_STATE,
  STAFF_STATE,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import { Store } from '@ngrx/store';
import { SkeletonModule } from 'primeng/skeleton';
import { InputNumberModule } from 'primeng/inputnumber';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { ActivatedRoute } from '@angular/router';
import { OtherPaymentComponent } from '@fitness-force/common/payment';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
import { PopoverModule } from 'primeng/popover';
import { environment } from 'apps/ff-frontend/src/environments/environment';


@Component({
  selector: 'pos-billing-summary',
  templateUrl: './pos-billing-summary.component.html',
  styleUrls: ['./pos-billing-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    InputNumberModule,
    ButtonModule,
    DrawerModule,
    AvatarModule,
    AvatarGroupModule,
    SelectModule,
    TooltipModule,
    DividerModule,
    DatePickerModule,
    ReactiveFormsModule,
    RadioButtonModule,
    MessageModule,
    CommonModule,
    SkeletonModule,
    CurrencyformatPipe,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    StyleClassModule,
    InputTextModule,
    InputMaskModule,
    DialogModule,
    OtherPaymentComponent,
    ShortNamePipe,
    PopoverModule,
    DialogModule,
    TranslateModule
]
})
export class PosBillingSummaryComponent implements OnInit {
  @Input('visible') showPosBillingSidebar = false;
  @Input('posSummaryData') posDetails$!: Observable<any>;
  @Output() closeSidePopup: EventEmitter<{ hideSidebar: boolean; clientSignupUUID: string; ispayment: boolean }> = new EventEmitter();


  disablePlanDropdown = false;
  getAccessTenantList$!: Observable<any>;
  tenantId = 0;
  subscriptionPlanId = 0;
  clientId = 0;
  clientName = '';
  isInclusive = false;
  isContract$ = new BehaviorSubject<boolean>(false);
  isCashRecurring = false;
  otherpayment = true;
  offlinePaymentPopup = false;
  otherPaymentsModal = false;
  billing_interval_type$ = new BehaviorSubject<string>('');
  billing_interval_value$ = new BehaviorSubject<number>(0);
  subscription_category$ = new BehaviorSubject<string>('');
  bill_cycle_day!: string;
  fg: UntypedFormGroup = new UntypedFormGroup({});
  planIntervalType = PlanIntervalType;
  planCategory = PlanType;
  oJSON!: JSON;
  isSubmitting = false;
  serviceTypeCollection!: Option[];
  errMsg: Error | any;
  error = new BehaviorSubject(null as AppErrors | null);
  boolshowSessionOwner = false;
  billedAtTenantId = 0;

  claim$: Observable<Claim[]> = new Observable();
  fgProducts: UntypedFormGroup = new UntypedFormGroup({
    charges: new UntypedFormArray([]),
    charges_reason : new UntypedFormControl('', []),
  });

  userDiscountLimit = 0;
  single_staff_discount = 0;
  recurring_staff_discount = 0;
  billingCycleOption$ = new BehaviorSubject<any[]>([]);
  isProRata$ = new BehaviorSubject(true);
  totalNonRecurringAmt$ = new BehaviorSubject(0);
  isTaxInClusive = false;
  billOwnerId$ = new BehaviorSubject<number>(0);

  planBreakUpCalculationResponse$ = new BehaviorSubject<PlanBreakUpCalculationResponse>(null!);
  overLappingSubscriptionSignUp$ = new BehaviorSubject<OverLappingSubscriptionSignUpResponse>(null!);
  planBreakUpCalculation$: BehaviorSubject<PlanBreakUpCalculation | null> = new BehaviorSubject<PlanBreakUpCalculation | null>(null);
  planSubscription$: BehaviorSubject<PlanMasterList[] | null> = new BehaviorSubject<PlanMasterList[] | null>(null);

  billdate: Date = new Date();
  maxStartDate = new Date();
  minStartDate = new Date();

  clientSignupUUID = '';
  selectedMembership: | { name: string; duration: string; amount: string } | undefined;
  startDate: Date | undefined;

  onlinePayment = false;
  // otherPayment: boolean = false;
  requiredInformation = false;

  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  errorDataModal = [] as ValidationError[];
  currentUserDetails: any;

  referredBy: number = 0;
  tenantDetails: TenantById;
  disableChargeMasterDropdown: boolean = false;
  chargeMasterid: number;
  clientIds: any;
  activeClientId: any;
  chargeCategoryCollection: Option[];
  chargeMasterList$ = new BehaviorSubject<ChargeMaster[]>([]);
  chargeMaster$: Observable<ChargeMasterById> = new Observable();
  chargeMaster: ChargeMasterById;
  totalBalance$ = new BehaviorSubject<number>(0);
  otherPaymentsModal$ = new BehaviorSubject<boolean>(false);

  applyDiscount: boolean = false;
  applyCoupon: boolean = false;
  couponApplied: boolean = false;
  discountApplied: boolean = false;
  inValidDiscount: Boolean = false;
  alreadyDiscountApplied = new BehaviorSubject(false);
  inValidRecurringDiscount: Boolean = false;
  _issueDate = "";
  changeBillingName = false;
  billingNameForm: UntypedFormGroup = new UntypedFormGroup({ billing_name: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]) });
  clientCreditBalance: number = 0;
  _selectedstaff = new BehaviorSubject<number>(0);
  _filterStaff = new BehaviorSubject<number[]>([0]);
  _sessionOwner = new BehaviorSubject<number[]>([0]);

  constructor(private store: Store,
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private clientService: ClientService,
    private plansubscriptionService: PlansubscriptionService,
    private commonService: CommonService,
    public authService: AuthSevices,
    public paymentModeService: PaymentModeService,
    private timeService: TimeconversionService,
    private staffService: StaffService,
    private toastMessageService: ToastMessageService,
    private activatedRouter: ActivatedRoute,
    private advanceSettingService: AdvancedSettingService,
    private chargeMasterService: ChargeMasterService,
    private claimService: ClaimService) {
    this.currentUserDetails = this.authService.decodedToken;
    this.componentInit();
  }

  ngOnInit(): void {

    this.maxStartDate = new Date(new Date().setHours(23,59,59));
    this.posDetails$.subscribe((plan: PlanSummary) => {
      this.tenantId = plan.tenant_id;
      this.clientId = plan.client.client_id;
      this.clientName = plan.client.client_name;
      this.chargeMasterid = plan.id;
      this.disableChargeMasterDropdown = plan.id == 0;
      this.activeClientId = plan.client.client_id;
      this.getSettings();
      this.BindServiceType();
      this.ListChargeMaster();
      this.ChargeMaster(plan.id);
      this.filterStaff();
      this.getClientCreditBalance();
    });
  }

  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.billedAtTenantId = this.tenantId;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.claim$ = this.claimService.GetClaim(environment.BASE_URL);
    this.activatedRouter.params.subscribe((params: any) => {
      if (params.clientId) {
        this.activeClientId = params.clientId;
      }
    });
    this.single_staff_discount = this.currentUserDetails.single_staff_discount;
    this._issueDate = this.timeService.ConvertLocalDateTimeToUTC(new Date());
    this.SetFormFields();
  }

  getClientCreditBalance() {
    this.clientService.getClientCreditBalanceByTenantId(this.clientId, this.tenantId).subscribe({
      next: (res: any) => {
        this.clientCreditBalance = res;
      }, error: () => {
      }
    });
  }

  SetFormFields(): void {
    this.fg = this.fb.group({
      billdate: new UntypedFormControl(new Date(), []),
      billingOwner: new UntypedFormControl('', [Validators.required]),
     
    });
  }

  BindServiceType(): void {
    this.chargeMasterService.getChargeCategoryMasters(this.tenantId).subscribe({
      next: (chargeCatTypes: any) => {
        this.chargeCategoryCollection = [];
        chargeCatTypes.items.forEach((catType: ServiceTypeResponse) => {
          let status = catType.status.toString();
          let varStatus: string = Status[Status.Active];
          if (status === varStatus) {
            this.chargeCategoryCollection.push({
              name: catType.name_primary_language,
              value: catType.id,
            });
          }
        });
      },
      error: () => {

      },
    });
  }

  ListChargeMaster() {
    this.chargeMasterService.getChargeMasters(this.tenantId).subscribe({
      next: (chargeList: any) => {
        let chargeMasterList = chargeList.items as ChargeMaster[];
        this.chargeMasterList$.next(chargeMasterList.filter(o => o.status.toString() === Status[Status.Active] || o.status == Status.Active));
      },
      error: () => {
      },
    });
  }

  ChargeMaster(chargerMasterId: number) {
    this.chargeMaster$ = this.chargeMasterService.getSingleChargeMaster(this.tenantId, chargerMasterId);
    this.chargeMaster$.subscribe({
      next: (chargeMaster: ChargeMasterById) => {
        this.chargeMaster = chargeMaster;
        this.bindChargeBreakUp(this.tenantId);
      },
      error: () => {
      },
    });
  }

  filterStaff() {
    let claim: Claim[] = {} as Claim[];
    let staffs: STAFFINTERFACE[] = [];
    let validStaff: number[] = [];
    this.claim$.pipe(combineLatestWith(this.store.select(STAFF_STATE)))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.staffList;
        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if (
              stf.role == Roles.Admin ||
              stf.role.toString() == Roles[Roles.Admin] ||
              stf.role == Roles.FFAdmin ||
              stf.role.toString() == Roles[Roles.FFAdmin] ||
              claim.filter(
                (o) =>
                  o.id == stf.claim_template_id &&
                  (o.can_admin_billing == true || o.can_do_billing == true)
              ).length > 0
            )
              validStaff.push(stf.id);
          });
          this._filterStaff.next(validStaff);
        }
        if (this.authService.currentUserDetails()) {
          var currentUserDetails = this.authService.currentUserDetails();
          if (
            currentUserDetails.role.toLowerCase() == 'admin' ||
            currentUserDetails.can_do_billing == 'true' ||
            currentUserDetails.can_admin_billing == 'true'
          ) {
            this._selectedstaff.next(Number(this.authService.loggedInStaffId));
          }
        }
      });
  }


  bindChargeBreakUp(tenant_id: number): void {
    let chargeBreakUpCalculationRequest: ChargeBreakUpCalculationRequest = {
      client_id: this.clientId,
      coupon_code: '',
      is_coupon_code_applied: false,
      issue_date: this._issueDate,
      charge_master_ids: [this.chargeMasterid]
    };
    this.plansubscriptionService.getChargeBreakUpCalculation(tenant_id, chargeBreakUpCalculationRequest)
      .subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.errorMessages = [];
          if (_objResponse.plan_breakup_calculation != null) {
            this.planBreakUpCalculationResponse$.next(_objResponse);
            this.planBreakUpCalculation$.next(
              _objResponse.plan_breakup_calculation
            );
            this.overLappingSubscriptionSignUp$.next(
              _objResponse.overlapping_subscription
            );
            this.initializeDynamicControl(
              _objResponse.plan_breakup_calculation
            );
          } else {
            if (
              _objResponse.overlapping_subscription
                .overlapping_subscription_signup != null
            ) {
              this.errorMessages.push(
                _objResponse.overlapping_subscription
                  .overlapping_subscription_signup.overlapping_errormessage
              );
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
            } else {
              if (
                _objResponse.overlapping_subscription
                  .overlapping_client_subscription.new_date != null
              ) {
                this.translate
                  .get('POS.MEMBERSHIP_ADDON.OVERLAP_SUBSCRIPTION', {
                    date: this.timeService.formatDate(
                      _objResponse.overlapping_subscription
                        .overlapping_client_subscription.new_date
                        .subs_start_date,
                      'mediumdate'
                    ),
                  })
                  .subscribe((translation) => {
                    this.errorMessages.push(translation);
                    this.errorDataModal = this.errorMessages;
                    this.showErrorPopup?.next(true);
                  });
              } else {
                this.errorMessages.push(
                  _objResponse.overlapping_subscription
                    .overlapping_client_subscription.overlapping_errormessage
                );
                this.errorDataModal = this.errorMessages;
                this.showErrorPopup?.next(true);
              }
            }
          }
        },
        error: (error: AppErrors) => {
          this.errorMessages = [];
          this.handleError(error);
        },
        complete: () => { },
      });
  }

  handleError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        if (e.identifier == 'OfferMasterCouponCodeLink' || e.identifier == 'CouponCodeValidation') {
          this.error.next(error);
          this.showErrorPopup?.next(true);
        }
        else {
          this.error.next(error);
          this.showErrorPopup?.next(true);
        }
      });
    } else {
      this.error.next(error);
      this.showErrorPopup?.next(true);
    }
  }

  SaveCharges(paymentObject: any) {
    let paymentSignUp: PaymentSignUp = {} as PaymentSignUp;
    paymentSignUp = paymentObject;
    const crm: Crm = {} as Crm;
    var newDate = new Date();
    const chargeCreateRequest = {
      issue_date: this.billDate.value,
      billing_name: this.billingNameFormControl.value ? this.billingNameFormControl.value : this.clientName,
      collected_at: this.billedAtTenantId,
      is_offline_payment: true,
      offline_payment: paymentSignUp,
      is_coupon_code_applied: false,
      sigup_coupon_code: '',
      sales_rep: this.billingOwner.value.id,
      charging_today: {} as ChargingTodaySignUp,
      charging_recurring: {} as RecurringSignUp
    } as ChargeCreateRequest;

    let _objResponse = this.planBreakUpCalculation$.getValue() as PlanBreakUpCalculation;
    chargeCreateRequest.charging_today = _objResponse.charging_today;
    chargeCreateRequest.charging_recurring = _objResponse.charging_recurring;
    
    if (chargeCreateRequest.charging_today && chargeCreateRequest.charging_today.signup_charges && chargeCreateRequest.charging_today.signup_charges.length > 0) {
      chargeCreateRequest.charging_today.signup_charges.forEach(o => {
        o.discount_reason = this.ChargesDiscountReason.value;
      })
    }
     this.isSubmitting = true;
     this.plansubscriptionService.CreateCharge(this.tenantId, this.clientId, chargeCreateRequest)
     .pipe(
      retryWhen(errors =>
        errors.pipe(
          // Check for the specific error condition that should trigger a retry
          scan((count, error) => {
            if (
              count < 2 && // Retry only 2 times
              error &&
              error.originalError.error &&
              error.originalError.error[0] &&
              error.originalError.error[0].errorCode === 'paymentamountgreaterthaninvoiceamount'
            ) {
              // Update the payload before retrying
              chargeCreateRequest.offline_payment.amount_in_minor_currency = chargeCreateRequest.offline_payment.rounded_amount_in_minor_currency!;
              return count + 1; // Increment the retry count
            }
            // Do not retry for other errors or after 3 retries
            throw error;
          }, 0),
          switchMap((retryCount) => timer(100))
        )
      ),
      catchError((error) => {
        return throwError(error);
      })
     ).subscribe({
        next: (_objResponse: ClientOrderResponse) => {
          this.isSubmitting = false;
          this.clientSignupUUID = _objResponse.charges_link_uuid;
          this.otherPaymentsModal$.next(false);
          this.closeBillingSideBar(_objResponse.charges_link_uuid);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.errorMessages.push([]);
          this.error.next(error);
          this.showErrorPopup?.next(true);
          this.otherPaymentsModal$.next(false);
        },
        complete: () => { },
      });
  }

  initializeDynamicControl(_objResponse: PlanBreakUpCalculation) {
    let fg: UntypedFormGroup = new UntypedFormGroup({});
    _objResponse.charging_today.signup_charges.forEach(
      (value: ChargeBreakUp) => {
        fg.addControl(
          'chargesbasecost_' + value.id.toString(),
          new UntypedFormControl(value.amount_in_minor_currency, [
            Validators.required,
          ])
        );
        fg.addControl(
          'charges_' + value.id.toString(),
          new UntypedFormControl(
            this.commonService.ConvertAmountFromMinorCurrency(
              this.getChargeNetCost(value)
            ),
            [Validators.required]
          )
        );
        fg.addControl(
          'discount_' + value.id.toString(),
          new UntypedFormControl(
            value.discount_amt_in_minor_currency,
            Validators.required
          )
        );
      }
    );
    this.charges.push(fg);

  }

  calculateDiscount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount = 0;
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(
      basePriceCtrl.value
    );
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      amtCtrl.value &&
      lineItemChargeAmount >= amtCtrl.value
    ) {
      disCtrl.setValue(100 - (amtCtrl.value * 100) / lineItemChargeAmount); // set discount
      //this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        //this.inValidDiscount = true;
      }, 10);
    }
  }

  calculateAmount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount: number = basePriceCtrl.value;
    lineItemChargeAmount =
      this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    let netValue =
      lineItemChargeAmount - (lineItemChargeAmount * disCtrl.value) / 100;
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      netValue
    ) {
      amtCtrl.setValue(netValue);
      //this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;

        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        //this.inValidDiscount = true;
      }, 10);
    }
  }



  ordinal_suffix_of(i: any) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + 'st';
    }
    if (j == 2 && k != 12) {
      return i + 'nd';
    }
    if (j == 3 && k != 13) {
      return i + 'rd';
    }
    return i + 'th';
  }

  getTotalBaseCost(serviceBreakUp: ServiceBreakUp[]): number {
    return serviceBreakUp?.reduce(function (acc, obj) {
      return acc + obj.base_cost_in_minor_currency;
    }, 0);
  }

  getTotal(serviceBreakUp: ServiceBreakUp[]): string {
    return serviceBreakUp
      .reduce(function (acc, obj) {
        return acc + obj.taxable_cost_in_minor_currency;
      }, 0)
      .toString();
  }

  getTotalTaxAmount(serviceBreakUp: ServiceBreakUp[]): number {
    let taxAmount = 0;
    serviceBreakUp?.forEach((value: ServiceBreakUp) => {
      if (value.tax)
        taxAmount =
          taxAmount +
          value.tax.reduce(function (acc, obj) {
            return acc + obj.amt_in_minor_currency;
          }, 0);
    });

    return taxAmount;
  }

  getTaxAmount(tax: TaxLineItemBreakUp[]): number {
    let taxAmount = 0;
    if (tax)
      taxAmount = tax.reduce(function (acc, obj) {
        return acc + obj.amt_in_minor_currency;
      }, 0);
    return taxAmount;
  }

  getTotalChargeTaxAmount(charge: ChargeBreakUp[]): number {
    let taxAmount = 0;
    charge.forEach((value: ChargeBreakUp) => {
      if (value.tax != null)
        taxAmount =
          taxAmount +
          value.tax.reduce(function (acc, obj) {
            return acc + obj.amt_in_minor_currency;
          }, 0);
    });
    return taxAmount;
  }



  formatDate(date: Date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(client.client_status.toString());
    else return '';
  }

  RequestAccess() {
    const reportRequestAccess = {
      claim: ClaimConstant.can_admin_billing,
      access_requested_friendly_name: ClaimConstant.can_admin_billing,
      request_access_comment: 'Claim Acess for Billing',
    };

    this.staffService.RequestAccess(reportRequestAccess).subscribe({
      next: () => {
        this.translate
          .get('STAFF.ACCESS.REQUEST_SUCCESS')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
          this.translate
            .get('REPORTS.ERROR_MSG.ERROR')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        } else {
          this.translate
            .get('STAFF.ACCESS.REQUEST_FAILED')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        }
      },
    });
  }



  OpenOfflinePayment() {
    this.totalBalance$.next(this.chargeMaster.amount_in_minor_currency);
    this.otherPaymentsModal$.next(true);

  }

  HideOtherPaymentDialog(evt: any) {
    if (evt.paymentSignUp) {
      this.SaveCharges(evt.paymentSignUp);
    }
    else
      this.otherPaymentsModal$.next(false);
  }

  closeOtherPaymentDialog(event:any)
  {
    this.otherPaymentsModal$.next(false);
  }

  get netCost$(): Observable<number> {
    let oThis = this;
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          var _value = value.plan_breakup_calculation.charging_today.service_first_charge.services?.reduce(
            function (acc, obj) {
              return (
                acc +
                oThis.getNetCost(
                  obj.taxable_cost_in_minor_currency,
                  oThis.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
          return _value;
        } else {
          return 0;
        }
      })
    );
  }

  get nonRecurringNetCost$(): Observable<number> {
    let oThis = this;
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          return value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(
            function (acc, obj) {
              return (
                acc +
                oThis.getNetCost(
                  obj.taxable_cost_in_minor_currency,
                  oThis.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
        } else return 0;
      })
    );
  }

  getChargesNetCost(taxableAmount: number, taxAmount: number): number {
    return this.isInclusive ? taxableAmount + taxAmount : taxableAmount;
  }

  getNetCost(taxableAmount: number, taxAmount: number): number {
    return this.isInclusive ? taxableAmount + taxAmount : taxableAmount;
  }

  getChargeNetCost(charge: ChargeBreakUp): number {
    return this.getNetCost(
      charge.taxable_cost_in_minor_currency,
      this.getTaxAmount(charge.tax)
    );
  }

  get charges(): UntypedFormArray {
    return this.fgProducts.get('charges') as UntypedFormArray;
  }

  get hasbillingRights(): boolean {
    return (
      this.currentUserDetails.role.toLowerCase() == 'admin' ||
      this.currentUserDetails.role == Roles.Admin ||
      this.currentUserDetails.role.toString() == Roles[Roles.Admin] ||
      this.currentUserDetails.can_do_billing === 'true'
    );
  }


  //#region firstTimeAmount
  get firstTimeAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeAmt as UntypedFormControl;
  }

  get firstTimeAmount(): number {
    return this.firstTimeAmountFormControl.value as number;
  }

  set firstTimeAmount(val: number) {
    this.firstTimeAmountFormControl.setValue(val);
  }

  get firstTimeTaxAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeTaxAmt as UntypedFormControl;
  }

  get firstTimeTaxAmount(): number {
    return this.firstTimeTaxAmountFormControl.value as number;
  }

  set firstTimeTaxAmount(val: number) {
    this.firstTimeTaxAmountFormControl.setValue(val);
  }

  get firstTimeDiscountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeDis as UntypedFormControl;
  }

  get firstTimeDiscount(): number {
    return this.firstTimeDiscountFormControl.value as number;
  }

  set firstTimeDiscount(val: number) {
    this.firstTimeDiscountFormControl.setValue(val);
  }

  //#endregion firstTimeAmount

  //#region nonRecurringAmount

  get nonRecurringAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringAmt as UntypedFormControl;
  }

  get nonRecurringAmount(): number {
    return this.nonRecurringAmountFormControl.value as number;
  }

  set nonRecurringAmount(val: number) {
    this.nonRecurringAmountFormControl.setValue(val);
  }

  get nonRecurringTaxAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringTaxAmt as UntypedFormControl;
  }

  get nonRecurringTaxAmount(): number {
    return this.nonRecurringTaxAmountFormControl.value as number;
  }

  set nonRecurringTaxAmount(val: number) {
    this.nonRecurringTaxAmountFormControl.setValue(val);
  }

  get nonRecurringDiscountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringDis as UntypedFormControl;
  }

  get nonRecurringDiscount(): number {
    return this.nonRecurringDiscountFormControl.value as number;
  }

  set nonRecurringDiscount(val: number) {
    this.nonRecurringDiscountFormControl.setValue(val);
  }

  //#endregion nonRecurringAmount

  //#region RecurringAmount

  //#region "getproperty"
  get planList() {
    return this.fg.controls.ddlplanSubscriptionList as UntypedFormControl;
  }

  get billingCycle() {
    return this.fg.controls.ddlBillingCycle as UntypedFormControl;
  }

  get billCycle() {
    return this.billingCycle.value;
  }

  get billingOwner() {
    return this.fg.controls.billingOwner as UntypedFormControl;
  }

  get billDate() {
    return this.fg.controls.billdate as UntypedFormControl;
  }

  get subscriptionStartdate() {
    return this.fg.controls.subscriptionstartdate as UntypedFormControl;
  }

  get couponCodeFormControl() {
    return this.fg.controls.couponCode as UntypedFormControl;
  }

  get couponCodeFormControlValue() {
    return this.couponCodeFormControl.value;
  }

  get ChargesDiscountReason(): UntypedFormControl {
    return this.fgProducts.controls.charges_reason as UntypedFormControl;
  }



  get totalOneTimeCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          let firstChargeCost: number = 0;
          let firstChargeTaxCost: number = 0;
          let nonRecurringChargeCost: number = 0;
          let nonRecurringTaxChargeCost: number = 0;
          let chargeCost: number = 0;
          let chargeTaxCost: number = 0;
          if (value && value.plan_breakup_calculation) {
            if (value.plan_breakup_calculation.charging_today.service_first_charge && value.plan_breakup_calculation.charging_today.service_first_charge.services
            ) {
              firstChargeCost =
                value.plan_breakup_calculation.charging_today.service_first_charge.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }

            if (value.plan_breakup_calculation.charging_today.service_first_charge && value.plan_breakup_calculation.charging_today.service_first_charge.services) {
              firstChargeTaxCost = this.getTotalTaxAmount(
                value.plan_breakup_calculation.charging_today
                  .service_first_charge.services
              );
            }
            if (value.plan_breakup_calculation.charging_today.service_non_recurring && value.plan_breakup_calculation.charging_today.service_non_recurring.services) {
              nonRecurringChargeCost =
                value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }

            if (value.plan_breakup_calculation.charging_today.service_non_recurring && value.plan_breakup_calculation.charging_today.service_non_recurring.services) {
              nonRecurringTaxChargeCost = this.getTotalTaxAmount(
                value.plan_breakup_calculation.charging_today
                  .service_non_recurring.services
              );
            }

            chargeCost =
              value.plan_breakup_calculation.charging_today.signup_charges.reduce(
                function (acc, obj) {
                  return acc + obj.taxable_cost_in_minor_currency;
                },
                0
              );

            chargeTaxCost = this.getTotalChargeTaxAmount(
              value.plan_breakup_calculation.charging_today.signup_charges
            );
          }
          var _value =
            (
              firstChargeCost +
              firstChargeTaxCost +
              nonRecurringChargeCost +
              nonRecurringTaxChargeCost +
              chargeCost +
              chargeTaxCost
            );

          return (_value == 0) ? 0.00000001 : _value;

        } else return 0;
      })
    );
  }


  get recurringCost$(): Observable<number> {
    let oThis = this;
    return this.planBreakUpCalculation$.pipe(
      map((value: PlanBreakUpCalculation | null) => {
        if (value) {
          return value.charging_recurring.services.reduce(function (acc, obj) {
            return (
              acc +
              obj.taxable_cost_in_minor_currency +
              oThis.getTaxAmount(obj.tax)
            );
          }, 0);
        } else return 0;
      })
    );
  }

  ApplyDiscount(value: any) {
    if (this.couponApplied) {
      this.alreadyDiscountApplied.next(true);
      this.applyDiscount = false;
    } else {
      this.applyDiscount = true;
      this.alreadyDiscountApplied.next(false);
      this.ChargesDiscountReason.addValidators([Validators.required]);
    }
  }


  calculateChargeDiscount(
    lineItemChargeAmount: number,
    amtCtrl: string,
    disCtrl: string
  ) {
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);

    let amtControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    let disControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      amtControl.value &&
      lineItemChargeAmount >= amtControl.value
    ) {
      disControl.setValue(
        100 - (amtControl.value * 100) / lineItemChargeAmount
      ); // set discount
      this.inValidDiscount = false;
    } else {
      setTimeout((obj: any) => {
        this.userDiscountLimit = this.single_staff_discount;

        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
      }, 10);
    }
  }

  calculateChargeAmount(
    lineItemChargeAmount: number,
    amtCtrl: string,
    disCtrl: string
  ) {
    let amtControl: any = (
      (this.fgProducts.controls.charges as UntypedFormArray)
        .controls[0] as UntypedFormGroup
    ).controls[amtCtrl];
    let disControl: any = (
      (this.fgProducts.controls.charges as UntypedFormArray)
        .controls[0] as UntypedFormGroup
    ).controls[disCtrl];

    lineItemChargeAmount =
      this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    let netValue =
      lineItemChargeAmount - (lineItemChargeAmount * disControl.value) / 100;

    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      netValue
    ) {
      amtControl.setValue(netValue);
      this.inValidDiscount = false;
    } else {
      setTimeout((obj: any) => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
      }, 10);
    }
  }


  closeBillingSideBar(sGuid: string) {
    this.closeSidePopup.emit({
      hideSidebar: false,
      clientSignupUUID: this.clientSignupUUID,
      ispayment: true
    });
  }

  StaffDiscountCancel() {
    this.inValidDiscount = false;
    this.applyDiscount=false;
    this.inValidRecurringDiscount = false;
    this.planBreakUpCalculation$.subscribe(
      (_objResponse: PlanBreakUpCalculation | null) => {
        if (_objResponse) {
          this.netCost$.subscribe((obj: number) => {
            this.firstTimeAmount =
              this.commonService.ConvertAmountFromMinorCurrency(obj);
            if (
              this.getTotalBaseCost(
                _objResponse.charging_today.service_first_charge.services
              ) -
              this.commonService.ConvertMinorCurrencyFromAmount(
                this.firstTimeAmount
              ) ==
              0
            ) {
              this.firstTimeDiscount = 0;
            } else {
              this.firstTimeDiscount =
                100 -
                (this.commonService.ConvertMinorCurrencyFromAmount(
                  this.firstTimeAmount
                ) *
                  100) /
                this.getTotalBaseCost(
                  _objResponse.charging_today.service_first_charge.services
                );
            }
          });

          this.nonRecurringNetCost$.subscribe((obj: number) => {
            this.nonRecurringAmount =
              this.commonService.ConvertAmountFromMinorCurrency(obj);

            if (
              this.getTotalBaseCost(
                _objResponse.charging_today.service_non_recurring.services
              ) -
              this.commonService.ConvertMinorCurrencyFromAmount(
                this.nonRecurringAmount
              ) ==
              0
            ) {
              this.nonRecurringDiscount = 0;
            } else {
              this.nonRecurringDiscount =
                100 -
                (this.commonService.ConvertMinorCurrencyFromAmount(
                  this.nonRecurringAmount
                ) *
                  100) /
                this.getTotalBaseCost(
                  _objResponse.charging_today.service_non_recurring.services
                );
            }
          });



          let frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
          let controlIds: Array<number> = [];

          Object.keys(frmCharges.controls).forEach((key) => {
            if (
              !controlIds.includes(
                parseInt(key.substring(key.indexOf('_') + 1))
              )
            )
              controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
          });

          let fg: UntypedFormGroup = new UntypedFormGroup({});
          _objResponse.charging_today.signup_charges.forEach(
            (value: ChargeBreakUp, index: number) => {
              controlIds.forEach((val) => {
                if (value.id.toString() == val.toString()) {
                  frmCharges.controls['charges_' + val.toString()].setValue(
                    this.commonService.ConvertAmountFromMinorCurrency(
                      this.getChargeNetCost(value)
                    )
                  );
                  if (
                    frmCharges.controls['chargesbasecost_' + val.toString()]
                      .value -
                    this.getChargeNetCost(value) ==
                    0
                  ) {
                    frmCharges.controls['discount_' + val.toString()].setValue(
                      0
                    );
                  } else {
                    frmCharges.controls['discount_' + val.toString()].setValue(
                      100 -
                      (this.getChargeNetCost(value) * 100) /
                      frmCharges.controls[
                        'chargesbasecost_' + val.toString()
                      ].value
                    );
                  }
                }
              });
            }
          );
        }
      }
    );
  }

  StaffDiscountBreakup() {

    if (this.ChargesDiscountReason && this.ChargesDiscountReason.invalid) {
      this.ChargesDiscountReason.markAsTouched();
      return;
    }

    this.applyDiscount=false;
    this.discountApplied= true;

    let staffDiscountCalculationRequest = {} as StaffDiscountCalculationRequest;
    let staffDiscountChargeRecurring = {} as StaffDiscountChargeRecurring;
    let staffDiscountChargingTodayRequest = {} as StaffDiscountChargingTodayRequest;
    let staffDiscountSignUpChargeRequest: StaffDiscountSignUpChargeRequest[] = [];

    staffDiscountChargingTodayRequest.service_first_charge = {} as StaffDiscountServiceFirstChargeRequest;
    staffDiscountChargingTodayRequest.service_non_recurring = {} as StaffDiscountServiceNonRecurringRequest;
    staffDiscountChargeRecurring.service_recurring = {} as StaffDiscountServiceRecurringRequest;


    staffDiscountCalculationRequest.client_id = this.clientId;
    staffDiscountCalculationRequest.issue_date = this._issueDate;

    staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = 0;
    staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountChargeRecurring.service_recurring.discount_amt_in_minor_currency = 0;

    // if (this.frmFirstTimeBaseCostAmount)
    //   staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = this.frmFirstTimeBaseCostAmount - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.firstTimeAmount));

    // if (this.frmNonRecurringBaseCostAmount)
    //   staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = this.frmNonRecurringBaseCostAmount - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.nonRecurringAmount));

    staffDiscountCalculationRequest.charging_recurring = staffDiscountChargeRecurring;
    //staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;

    let frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    let controlIds: Array<number> = [];

    //get charges control id.
    Object.keys(frmCharges.controls).forEach((key) => {
      if (!controlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
        controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
    });

    staffDiscountChargingTodayRequest.signup_charges = [];

    controlIds.forEach((val) => {
      let staffDiscountSignupCharge = {} as StaffDiscountSignUpChargeRequest;
      staffDiscountSignupCharge.id = val;
      staffDiscountSignupCharge.discount_amt_in_minor_currency = frmCharges.controls['chargesbasecost_' + val.toString()].value - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(frmCharges.controls['charges_' + val.toString()].value));

      staffDiscountSignUpChargeRequest.push(staffDiscountSignupCharge);

      //Set Value.
      staffDiscountChargingTodayRequest.signup_charges = staffDiscountSignUpChargeRequest;
    });

    staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;

    this.plansubscriptionService
      .getStaffDiscountChargeCalculation(
        this.tenantId,
        staffDiscountCalculationRequest
      )
      .subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.planBreakUpCalculationResponse$.next(_objResponse);
          this.planBreakUpCalculation$.next(
            _objResponse.plan_breakup_calculation
          );
          this.overLappingSubscriptionSignUp$.next(
            _objResponse.overlapping_subscription
          );
        },
      });
  }

  RemoveDiscount(): void {
    this.alreadyDiscountApplied.next(false);
    this.ChargesDiscountReason.reset();
    this.ChargesDiscountReason.removeValidators(Validators.required);
    let staffDiscountCalculationRequest = {} as StaffDiscountCalculationRequest;
    let staffDiscountChargeRecurring = {} as StaffDiscountChargeRecurring;
    let staffDiscountChargingTodayRequest = {} as StaffDiscountChargingTodayRequest;
    let staffDiscountSignUpChargeRequest: StaffDiscountSignUpChargeRequest[] = [];

    staffDiscountChargingTodayRequest.service_first_charge = {} as StaffDiscountServiceFirstChargeRequest;
    staffDiscountChargingTodayRequest.service_non_recurring = {} as StaffDiscountServiceNonRecurringRequest;
    staffDiscountChargeRecurring.service_recurring = {} as StaffDiscountServiceRecurringRequest;

    staffDiscountCalculationRequest.client_id = this.clientId;
    staffDiscountCalculationRequest.issue_date = this._issueDate;

    staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = 0;
    staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountChargeRecurring.service_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountCalculationRequest.charging_recurring = staffDiscountChargeRecurring;

    let frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    let controlIds: Array<number> = [];

    //get charges control id.
    Object.keys(frmCharges.controls).forEach((key) => {
      if (!controlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
        controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
    });

    controlIds.forEach((val) => {
      let staffDiscountSignupCharge = {} as StaffDiscountSignUpChargeRequest;
      staffDiscountSignupCharge.id = val;
      staffDiscountSignupCharge.discount_amt_in_minor_currency = 0;
      staffDiscountSignUpChargeRequest.push(staffDiscountSignupCharge);
      //Set Value.
      staffDiscountChargingTodayRequest.signup_charges = staffDiscountSignUpChargeRequest;
      staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;
    });

    this.plansubscriptionService.getStaffDiscountChargeCalculation(this.tenantId,staffDiscountCalculationRequest)
      .subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.planBreakUpCalculationResponse$.next(_objResponse);
          this.planBreakUpCalculation$.next(
            _objResponse.plan_breakup_calculation
          );
          this.overLappingSubscriptionSignUp$.next(
            _objResponse.overlapping_subscription
          );

          let frmCharges: UntypedFormGroup = (
            this.fgProducts.controls.charges as UntypedFormArray
          ).controls[0] as UntypedFormGroup;

          _objResponse.plan_breakup_calculation.charging_today.signup_charges.forEach(
            (value: ChargeBreakUp, index: number) => {
              frmCharges.controls[
                'chargesbasecost_' + value.id.toString()
              ].setValue(value.amount_in_minor_currency);
              frmCharges.controls['charges_' + value.id.toString()].setValue(
                this.commonService.ConvertAmountFromMinorCurrency(
                  this.getChargeNetCost(value)
                )
              );
              frmCharges.controls['discount_' + value.id.toString()].setValue(
                value.discount_amt_in_minor_currency
              );
            }
          );
        },
        error: (error: any) => {
          this.discountApplied = false;
        }
      });
  }

  getSettings() {
    let settings = this.advanceSettingService.getAdvanceSettings(
      this.tenantId
    );
    if (settings) {
      settings.subscribe({
        next: (res: any) => {
          if (res.items != null) {

            //tax calculation
            let tax_calculation: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "tax_calculation")
            if (tax_calculation != null) {
              if (tax_calculation.value.toLowerCase() == 'inclusive')
                this.isInclusive = true;
            }


            //backdated_billing_setting
            let backdated_billing_setting: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "backdated_billing_setting")
            if (backdated_billing_setting != null) {
              if (backdated_billing_setting.value > 0)
                this.minStartDate.setDate(this.minStartDate.getDate() - parseInt(backdated_billing_setting.value));
            }
          }
        },
      });
    }
  }

  get billingNameFormControl(): UntypedFormControl {
    return this.billingNameForm.controls.billing_name as UntypedFormControl;
  }

  removeBillingName() {
    this.billingNameFormControl.setValue('');
  }

  HideErrorPopup() {
    this.errorMessages = [];
    this.errorDataModal = [];
    this.showErrorPopup?.next(false);
  }

}

interface Option {
  name: string;
  value: number;
}
